import {ChevronDownIcon, ChevronRightIcon, TagIcon, XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import SelectHtmlTag from "../../../content/components/rich-text-editor/select-html-tag";
import GenerateContentFromPrompt from "../../../openai/components/generate-content-from-prompt";
import {PRODUCT_BLOG_POST_PROMPTS} from "../../constants/product-blog-post.constant";
import DeletePostContentLine from "./delete-post-content-line";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";


const ProductBlogPostPreviewMode = ({contentLines, htmlContent = ''}) => {
    return (
        <>
            {/*<div className={'w-full p-4'}
                 dangerouslySetInnerHTML={{__html: htmlContent}}/>*/}

            <div>
                <ReactMarkdown
                    children={htmlContent}
                    rehypePlugins={[rehypeRaw]}
                    skipHtml={false}
                    className="mt-2 content-container pb-4 px-2"/>
            </div>

            {/*<div className={'w-full p-4'}>
                {contentLines?.map((contentLine, contentLineIndex) => (
                    <div key={`contentLine-${contentLineIndex}`}
                         className={``}>
                        <div className={`w-full p-2`}>
                            <div
                                className={`flex justify-start items-center
                                ${contentLine.newType === 'h3' ? 'font-bold text-sky-500' : ''}
                                ${contentLine.isSection ? 'font-bold text-pink-500' : ''}
                                ${contentLine.isImage ? 'font-bold text-purple-500' : ''}`}>
                                {contentLine.isImage &&
                                    <div className={'mr-2'}>
                                        <ProductImageSmall
                                            afterImageSelected={(event) => {
                                            }}
                                            dimension={100}
                                            imageUrl={contentLine?.url}/>
                                    </div>
                                }
                                {contentLine?.text}
                                {contentLine.isImage &&
                                    <div className={'ml-2'}>
                                        - {contentLine?.productImageId}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>*/}
        </>
    )
}

export default ProductBlogPostPreviewMode
